export default __webpack_public_path__ + "static/media/logo2026.f2739b52.png";